// Healthcare role taxonomy for iConcierge.
// Grouped so the Register/Profile dropdown can show clear sections.
// Medical Assistants are intentionally grouped with the rest of clinical staff.

export const ROLE_CATEGORIES = [
  {
    key: "clinical",
    label: "Clinical Staff",
    icon: "Stethoscope",
    titles: [
      "Physician (MD/DO)",
      "Nurse Practitioner (NP)",
      "Physician Assistant (PA)",
      "Registered Nurse (RN)",
      "Licensed Practical Nurse (LPN)",
      "Medical Assistant (MA)",
      "Therapist (PT / OT / SLP)",
      "Chiropractor",
      "Dentist",
      "Optometrist",
      "Pharmacist",
      "Behavioral Health (Psychologist, LCSW, Counselor)",
    ],
  },
  {
    key: "practice",
    label: "Practice Staff",
    icon: "Building2",
    titles: [
      "Office Manager",
      "Practice Administrator",
      "Front Desk / Receptionist",
      "Medical Records / Billing",
      "Referral Coordinator",
      "Patient Care Coordinator",
      "Scheduler",
    ],
  },
  {
    key: "sales",
    label: "Sales & Industry",
    icon: "Briefcase",
    titles: [
      "Medical Device Rep",
      "Pharmaceutical Rep",
      "Medical Equipment Rep",
      "Lab / Diagnostic Rep",
      "Healthcare Marketing",
      "Healthcare Consultant",
    ],
  },
  {
    key: "other",
    label: "Other",
    icon: "Users",
    titles: [
      "Healthcare Executive / Owner",
      "Student / Resident",
      "Other",
    ],
  },
];

// Flat list helper for dropdowns + search
export const ALL_ROLE_TITLES = ROLE_CATEGORIES.flatMap((c) =>
  c.titles.map((t) => ({ category: c.key, categoryLabel: c.label, title: t }))
);

export const findCategoryForTitle = (title) => {
  for (const cat of ROLE_CATEGORIES) {
    if (cat.titles.includes(title)) return cat.key;
  }
  return "other";
};
